import React, {Component} from 'react';
import {Field} from 'redux-form';
import moment from "moment";
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';
import {RadioButton} from 'material-ui/RadioButton';
import injectTapEventPlugin from 'react-tap-event-plugin';
import {
  Checkbox,
  RadioButtonGroup,
  SelectField,
  TextField,
} from 'redux-form-material-ui';

import zahl2string from '../../Zaehler';
import * as constants from '../../constants';

const ChevronRight = require('react-icons/lib/md/chevron-right');
const ChevronLeft = require('react-icons/lib/md/chevron-left');
const Check = require('react-icons/lib/md/check');

const style = {
  margin: 12,
};

const contentStyle = {
  contentAlign: 'left',
  textAlign: 'left',
  display: 'inline-block',
};

const errorStyle = {
  textDecoration: 'overline',
  marginBottom: 30,
  fontSize: 12,
  color: 'red',
  contentAlign: 'left',
  textAlign: 'left',
  display: 'inline-block',
};

const red = {
  color: 'red',
};

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

class ChildForm extends Component {
  render() {
    const {
      handleSubmit,
      onPrevious: handlePrevious,
      onNext: handleNext,
      onSummary: handleSummary,
      onBirthdayBlur: handleBirthdayBlur,
      myErrors,
      viewportWidth,
      kindNr,
      formValues,
    } = this.props;

    let alter = "";
    if(formValues && formValues.geburtsdatum) {
      let geburtsdatum = moment(formValues.geburtsdatum, constants.DATE_FORMAT);
      alter = moment().diff(geburtsdatum, 'years');
    }

    return (
      <form key={`childForm-${kindNr}`}>
        <div>
          <h1>Ratzgiwatz Jugendprogramm Web-Anmeldung</h1>
          <h3>Eingabe der Daten des {zahl2string(kindNr)} Kindes</h3>
          <div style={contentStyle}>
            <Field
              autoFocus
              name="vorname"
              floatingLabelText="Vorname"
              component={TextField}
            />
            <br />
            <Field
              name="nachname"
              floatingLabelText="Nachname"
              component={TextField}
            />
            <br />
            <Field
              name="geburtsdatum"
              floatingLabelText="Geburtsdatum"
              hintText="Format: TT.MM.JJJJ"
              component={TextField}
              onBlur={handleBirthdayBlur}
            />
            <br/>
            {!isNaN(alter) ? "Aktuelles Alter: " : ""}
            {alter < 13 || alter > 16 ? <b style={red}>{alter}</b> : isNaN(alter) ? <b style={red}>Ungültiges Datumsformat</b> : `${ alter }` }

            <br />
            <Field
              name="tshirtGroesse"
              component={SelectField}
              floatingLabelText="T-Shirt Größe"
              value={0}
            >
              <MenuItem value={1} primaryText="86/92"/>
              <MenuItem value={2} primaryText="98/104"/>
              <MenuItem value={3} primaryText="110/116"/>
              <MenuItem value={4} primaryText="122/128"/>
              <MenuItem value={5} primaryText="134/140"/>
              <MenuItem value={6} primaryText="146/152"/>
              <MenuItem value={7} primaryText="S"/>
              <MenuItem value={8} primaryText="M"/>
              <MenuItem value={9} primaryText="L"/>
              <MenuItem value={10} primaryText="XL"/>
              <MenuItem value={11} primaryText="XXL"/>
            </Field>
            <br />
            <Field
              name="tetanusImpfungVorhanden"
              component={Checkbox}
              label="Tetanus Impfung vorhanden (Wundstarrkrampf)"
            />
            <br />
            <Field
              name="geschlecht"
              component={RadioButtonGroup}
            >
              <RadioButton
                value="m"
                label="männlich"
              />
              <RadioButton
                value="w"
                label="weiblich"
              />
            </Field>
            {this.props.submitFailed && myErrors && myErrors.geschlecht &&
            <div style={errorStyle}>{myErrors.geschlecht}</div>}
            <br />
            <Field
              name="allergien"
              hintText="bekannte Allergien / Unverträglichkeiten"
              multiLine={true}
              component={TextField}
            />
            <br />
            <Field
              name="sonstiges"
              hintText="Aktion bzw. Aktionen zu dem das Kind angemeldet werden soll."
              multiLine={true}
              component={TextField}
            />
          </div>
          <br />
          <RaisedButton
            style={style}
            label={viewportWidth < 400 ? `Korrektur` : `Daten korrigieren`}
            onTouchTap={handlePrevious}
            icon={<ChevronLeft/>}
          />
          <nbsp/>
          <RaisedButton
            style={style}
            label={viewportWidth < 500 ? `Nächstes Kind` : `Daten des ${zahl2string(kindNr + 1)} Kindes angeben`}
            onTouchTap={handleSubmit(data => { handleNext(data) })}
            icon={<ChevronRight/>}
          />
          <RaisedButton
            style={style}
            label={viewportWidth < 400 ? `Fertig` : `Anmeldung abschließen`}
            onTouchTap={handleSubmit(data => { handleSummary(data) })}
            primary={true}
            icon={<Check/>}
          />
        </div>
      </form>
    );
  }
}

export default ChildForm;



// WEBPACK FOOTER //
// ./src/components/child/ChildForm.jsx